var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestTube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96861 37.6213C4.01046 41.597 4.01046 48.0428 7.96861 52.0185C11.9268 55.9943 18.3442 55.9943 22.3024 52.0185L31.6668 42.6128L27.2365 40.7738C25.2943 39.9378 23.9499 38.1173 23.7165 36.008C23.4135 33.2688 21.2606 31.1063 18.5334 30.802H14.7579L7.96861 37.6213Z",
    fill: "#D6E6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4063 5.58267C34.189 4.80335 35.4555 4.80615 36.2348 5.5889L54.4175 23.852C55.1968 24.6348 55.194 25.9012 54.4113 26.6805C53.6283 27.4597 52.362 27.457 51.5828 26.6742L33.4 8.4111C32.6208 7.62832 32.6235 6.362 33.4063 5.58267Z",
    fill: "#D6E6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.2252 10.2441L7.96859 37.6212C4.01047 41.597 4.01047 48.0427 7.96859 52.0185C11.9267 55.994 18.3442 55.994 22.3023 52.0185L49.559 24.6413L35.2252 10.2441Z",
    fill: "#D6E6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestTube);
export default __webpack_public_path__ + "static/media/testTube.57fe72147c9ff78e3df01fd6a5f04add.svg";
export { ForwardRef as ReactComponent };